import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Classes, Position, Icon, Menu, MenuDivider } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import cx from 'classnames';

import { MenuElementType } from '@f/hooks';

import cls from './Nav.module.css';

export type ExtendedMenuElementType = MenuElementType & {
  children?: ExtendedMenuElementType[];
};

type MenuElementProps = {
  element: ExtendedMenuElementType;
  dropdownContent?: ReactNode;
};

export function MenuElement(props: MenuElementProps) {
  const { element, dropdownContent } = props;
  const { children } = element;

  if (!children || (children.length === 1 && !dropdownContent)) {
    const finalElement = children ? children[0] : element;

    return (
      <NavLink className={cls.link} to={finalElement.path as string}>
        {finalElement.title}
      </NavLink>
    );
  }

  return (
    <Popover2
      className={cls.dropdown}
      placement={Position.BOTTOM}
      content={
        <Menu large>
          {children.map(child => (
            <NavLink
              className={cx(Classes.MENU_ITEM, Classes.POPOVER_DISMISS, cls.link)}
              to={child.path as string}
              activeClassName={cx(Classes.ACTIVE, Classes.INTENT_PRIMARY)}
              key={child.title}
              data-cy={`menu-${child.tabId}`}
            >
              {child.title}
            </NavLink>
          ))}

          {dropdownContent && (
            <>
              <MenuDivider />
              {dropdownContent}
            </>
          )}
        </Menu>
      }
    >
      <span>
        <span className={cls.dropdownTitle}>{element.title}</span>
        <Icon icon="chevron-down" />
      </span>
    </Popover2>
  );
}
